var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 37H20.0005V27H25.0005V37ZM27.0005 27V37L36.0005 42V22L27.0005 27ZM38.0085 29.093C38.7505 29.836 39.2085 30.863 39.2065 31.996C39.2045 33.129 38.7445 34.154 38.0015 34.896L39.2205 36.119C40.2775 35.066 40.9325 33.608 40.9355 31.998C40.9375 30.387 40.2875 28.93 39.2335 27.873L38.0085 29.093V29.093ZM40.1505 26.958C41.4385 28.25 42.2325 30.031 42.2295 31.999C42.2265 33.967 41.4255 35.749 40.1335 37.038L41.3835 38.292C42.9955 36.684 43.9965 34.458 43.9995 32.001C44.0045 29.544 43.0135 27.32 41.4045 25.708L40.1505 26.958V26.958Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/soundOn.bdd11aa9.svg";
export { ForwardRef as ReactComponent };